<template>
  <div class="welcome">
    <!-- 主要内容 -->
    <div class="welcome__content">
      <!-- 成功图标 -->
      <IconCircleSuccess class="welcome__icon" />

      <template v-if="type === 'register'">
        <!-- 标题 -->
        <h1 class="welcome__title">{{ $t('zhu-ce-cheng-gong') }}</h1>

        <!-- 副标题 -->
        <p class="welcome__subtitle">
          {{ $t('gong-xi-cheng-wei-you-yan-yong-hu-nin-jiang-huo-de') }}
        </p>

        <!-- 福利列表 -->
        <div class="welcome__benefits">
          <div class="welcome__benefit-item">
            <div class="welcome__benefit-item-dot"></div>
            <div class="welcome__benefit-item-content">
              <div class="welcome__benefit-title">
                {{ $t('mei-yue-300-mian-fei-yan-bi') }}
              </div>
              <div class="welcome__benefit-desc">
                {{ $t('ke-yi-sheng-cheng-yue-4-fen-zhong-shi-pin-540p') }}
              </div>
            </div>
          </div>

          <div class="welcome__benefit-item">
            <div class="welcome__benefit-item-dot"></div>
            <div class="welcome__benefit-item-content">
              <div class="welcome__benefit-title">
                {{ $t('shu-qian-kuan-shu-zi-ren-xing-xiang-chang-jing-ai-sheng-yin') }}
              </div>
              <div class="welcome__benefit-desc">
                {{ $t('xian-shi-mian-fei') }}
              </div>
            </div>
          </div>

          <div class="welcome__benefit-item">
            <div class="welcome__benefit-item-dot"></div>
            <div class="welcome__benefit-item-content">
              <div class="welcome__benefit-title">
                {{ $t('ai-sheng-cheng-ppt-mian-fei-yong') }}
              </div>
              <div class="welcome__benefit-desc">
                {{ $t('ti-yan-ban-yong-hu-mei-ri-ke-shi-yong-3-ci') }}
              </div>
            </div>
          </div>

          <div class="welcome__benefit-item">
            <div class="welcome__benefit-item-dot"></div>
            <div class="welcome__benefit-item-content">
              <div class="welcome__benefit-title">
                {{ $t('geng-duo-xian-shi-mian-fei-quan-yi') }}
              </div>
              <div class="welcome__benefit-desc">
                {{ $t('ren-wu-zi-ding-yi-bian-ji-ppt-mo-ban-ku') }}
              </div>
            </div>
          </div>
        </div>
      </template>

      <template v-if="type === 'login'">
        <h1 class="welcome__title">{{ $t('deng-lu-cheng-gong') }}</h1>
        <p class="welcome__subtitle">
          {{ $t('huan-ying-hui-dao-you-yan-ping-tai-le-jie-jin-qi-geng-xin') }}
        </p>

        <!-- 福利列表 -->
        <div class="welcome__updates">
          <div class="welcome__updates-item">
            <div class="welcome__updates-item-dot"></div>
            <div class="welcome__updates-item-content">
              <div class="welcome__updates-title">
                {{ $t('xin-gong-neng-xing-xiang-he-sheng-yin-ke-long') }}
              </div>
              <div class="welcome__updates-desc">
                {{ $t('ke-long-ni-de-zhuan-shu-3d-jiao-se') }}
              </div>
            </div>
          </div>

          <div class="welcome__updates-item">
            <div class="welcome__updates-item-dot"></div>
            <div class="welcome__updates-item-content">
              <div class="welcome__updates-title">
                {{ $t('xin-gong-neng-ai-sheng-cheng-ppt') }}
              </div>
              <div class="welcome__updates-desc">
                {{ $t('mei-ri-huo-qu-mian-fei-shi-yongedu') }}
              </div>
            </div>
          </div>

          <div class="welcome__updates-item">
            <div class="welcome__updates-item-dot"></div>
            <div class="welcome__updates-item-content">
              <div class="welcome__updates-title">
                {{ $t('xing-neng-ti-sheng-shi-pin-ai-sheng-cheng-xiao-shuai-jia-bei') }}
              </div>
              <div class="welcome__updates-desc">
                {{ $t('shi-pin-ai-sheng-cheng-he-dao-chu-de-deng-dai-shi-chang-suo-duan-2-bei') }}
              </div>
            </div>
          </div>

          <div class="welcome__updates-item">
            <div class="welcome__updates-item-dot"></div>
            <div class="welcome__updates-item-content">
              <div class="welcome__updates-title">
                {{ $t('geng-duo-xin-nei-rong-deng-ni-fa-xian') }}
              </div>
              <div class="welcome__updates-desc">
                {{ $t('ppt-bian-ji-ppt-zhuan-shi-pin-jiao-ben') }}
              </div>
            </div>
          </div>
        </div>
      </template>

      <div class="welcome__bottom">
        <!-- 按钮区域 -->
        <div class="welcome__actions">
          <Button
            variant="border-back"
            size="large"
            class="welcome__btn welcome__btn--secondary"
            @click="handleContinueMobile"
          >
            {{ $t('ji-xu-liu-lan-shou-ji-duan-nei-rong') }}
          </Button>
          <Button
            variant="purple"
            size="large"
            class="welcome__btn welcome__btn--primary"
            @click="handleGoPC"
          >
            {{ $t('qian-wang-dian-nao-duan-ti-yan-wan-zheng-gong-neng') }}
          </Button>
        </div>

        <!-- 底部提示 -->
        <p class="welcome__hint">
          {{
            $t(
              'dian-ji-fu-zhi-you-yan-guan-wang-lian-jie-huo-shi-yong-dian-nao-liu-lan-qi-sou-suo-you-yan-deng-lu',
            )
          }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts" name="RegisterSuccess">
import { useMessage } from '@rendora/common/composables/message';
import IconCircleSuccess from '@rendora/design/assets/circle-success.svg?component';
import { Button } from '@rendora/design/components/button';
import { useI18n } from 'vue-i18n';
import { copy } from '~/utils/copy';
const route = useRoute();
const message = useMessage();
const { t: $t } = useI18n();
const type = computed(() => (route.query.type as 'login' | 'register' | undefined) || 'login');

// 复制链接并显示 toast
const handleCopyLink = async () => {
  const url = window.location.origin;
  try {
    await copy(url);
    message.success($t('cheng-gong-fu-zhi-lian-jie-qing-shi-yong-dian-nao-deng-lu'));
  } catch (_e) {
    message.error(
      $t(
        'lian-jie-huo-qu-shi-bai-qing-shi-yong-dian-nao-liu-lan-qi-sou-suo-you-yan-deng-lu-shi-yong',
      ),
    );
  }
};

// 继续浏览手机端内容
const handleContinueMobile = () => {
  navigateTo('/');
};

// 前往电脑端
const handleGoPC = async () => {
  await handleCopyLink();
};
</script>

<style lang="scss" scoped src="./mobile.scss"></style>
